import { SIZES } from "@/ui/ts/types/Sizes";
const { MEDIUM, LARGE } = SIZES;
export const CarouselDesktopSizes = {
  MEDIUM,
  LARGE
};
export var ECarouselDesktopWidth = /* @__PURE__ */ ((ECarouselDesktopWidth2) => {
  ECarouselDesktopWidth2["GRID"] = "grid";
  ECarouselDesktopWidth2["FULL"] = "full";
  return ECarouselDesktopWidth2;
})(ECarouselDesktopWidth || {});
export var EMobileSlidesVariants = /* @__PURE__ */ ((EMobileSlidesVariants2) => {
  EMobileSlidesVariants2["FULLWIDTH"] = "fullwidth";
  EMobileSlidesVariants2["ONE_BIG_CARD"] = "oneBigCard";
  EMobileSlidesVariants2["ONE_SMALL_CARD"] = "oneSmallCard";
  EMobileSlidesVariants2["TWO_CARDS"] = "twoCards";
  EMobileSlidesVariants2["THREE_CARDS"] = "threeCards";
  EMobileSlidesVariants2["FOUR_CARDS"] = "fourCards";
  EMobileSlidesVariants2["CUSTOM"] = "custom";
  return EMobileSlidesVariants2;
})(EMobileSlidesVariants || {});
export var ECarouselAlign = /* @__PURE__ */ ((ECarouselAlign2) => {
  ECarouselAlign2["START"] = "start";
  ECarouselAlign2["CENTER"] = "center";
  ECarouselAlign2["END"] = "end";
  return ECarouselAlign2;
})(ECarouselAlign || {});
